import script from "./AlbumDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlbumDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"

import "./AlbumDynamicTopMatter.vue?vue&type=style&index=0&id=cb0ee6dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb0ee6dc"]])

export default __exports__